export default class HeaderLanguageSwitcher {
	static init() {
		Array.from(document.querySelectorAll('.header-language-switcher')).forEach(element => {
			new HeaderLanguageSwitcher(element);
		});
	}

	constructor(element) {
		this.element = element;
		this.triggerElement = element.querySelector('.language-trigger');
		this.triggerElement.addEventListener('click', (e) => this.onTriggerClick(e));

		window.addEventListener('click', (e) => {
			if(e.target && !e.target.closest('.header-language-switcher')) {
				this.closeLanguageSwitcher();
			}
		});

		/*
		// TODO WHAT IS THIS SUPPOSED TO DO?
		$(document).on('click', '.search-trigger', function () {
			if ($('.header-search .field').is(':visible')) {
				$('.header-search .field').fadeOut(350);
				$(this).removeClass('active');
			} else {
				$('.header-search .field').fadeIn(350);
				setTimeout(function () {
					$('.header-search .field .input').focus();
				}, 100);
				$(this).addClass('active');
			}
			return false
		});
		*/
	}

	onTriggerClick(e) {
        e.preventDefault();

		if (this.element.classList.contains('open')) {
			this.closeLanguageSwitcher();
		} else {
			this.triggerElement.classList.add('active');
			this.element.classList.add('open');
		}
	}

	closeLanguageSwitcher() {
		this.triggerElement.classList.remove('active');
		this.element.classList.remove('open');
	}
}
